<template>
  <Section :content="searchAPI" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionSearchAPI',
  components: {
    Section,
  },
  data() {
    return {
      
    }
  },
  computed: {
    searchAPI() {
      var path = this.$route.path;
      var learnMoreLink = '';
     /* if (path === '/trinapp') {
        learnMoreLink = '/trinapp-search';
      }*/
      return { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Search API',
        paragraphs: [
          'As easy to use as a Google search box but focused on only the information needed, whether across all pods or only inside the current pod. Text searches return highly relevant results within Unit of Thought contexts, and system tag searches return all linked objects to that system. All results include the full object hierarchy up for easy navigation and discovery.'
        ],
        id: 'search-api',
        image: 'search-image.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        learnMoreLink: learnMoreLink,
      }
    } 
  }
};
</script>
